import { CircularProgress, Tab, TabList, TabPanel, Tabs, tabClasses } from "@mui/joy";
import { useGetEmpresaInfoByIdQuery } from "../../features/empresas/empresaApi";
import { EmpresaUltimaVisita } from "./EmpresaUltimaVisita";
import { ComentariosDeals } from "./ComentariosDeals";
import { DatosGeneralesContainer } from "./DatosGeneralesContainer";
import { ContactoContainer } from "./ContactosContainer";
import { isFetchBaseQueryError } from "src/utils/errorHelpers";
import { useErrorHandling } from "src/features/empresas/EmpresaDetails/context/ErrorHandlingContext";

interface Props {
    empresaId: number;
}

export function EmpresaFullInfo({ empresaId }: Props) {
    const { reportError } = useErrorHandling();

	const { 
        data: empresaInfo,
        isLoading,
        error,
    } = useGetEmpresaInfoByIdQuery({ empresaId }, { refetchOnMountOrArgChange: true });

    if (isFetchBaseQueryError(error)) {
        if(typeof error.status == "number")
            reportError(error.status);
    }

    if (isLoading)
        return (
        <div className="border-r-2 border-r-gray-300 col-span-1 row-span-3 w-1/3 h-full">
            <CircularProgress />
        </div>
    );

    return (
        <div className="border-r-2 border-r-gray-300 col-span-1 row-span-3 w-1/3 h-full">
            {isLoading || empresaInfo === undefined
            ? 
            <div className="flex justify-center items-center h-full">
                <CircularProgress/>
            </div>
            : 
            <div className="h-full">
                <Tabs
                    aria-label="tabs"
                    defaultValue={0}
                    sx={{ 
                        maxHeight: "100%",
                        overflowY: "auto",
                        bgcolor: 'transparent',
                        "--Tab-indicatorThickness": "2px",
                    }}>
                    <TabList
                        tabFlex="auto"
                        sx={{
                            [`& .${tabClasses.root}[aria-selected="true"]`]: {
                                boxShadow: 'sm',
                                bgcolor: "rgba(156, 163, 175, 0.3)",
                            },
                            height: "100%",
                            width: "100%",
                            scrollSnapType: "x mandatory",
                            bgcolor: "white",
                            fontWeight: 600,
                            fontSize: 14
                        }}>
                        <Tab>Datos Generales</Tab>
                        <Tab>Contactos</Tab>
                        <Tab>Última Visita</Tab>
                        <Tab>Comentarios</Tab>
                    </TabList>

                    <TabPanel 
                        value={0}
                        sx={{
                            height: "100%",
                            minHeight: "100%",
                            maxHeight: "100%",
                            overflow: "auto",
                        }}>
                        <DatosGeneralesContainer
                            empresaId={empresaId}
                            datosGenerales={empresaInfo.datosGenerales}/>
                    </TabPanel>
                    <TabPanel value={1}
                        sx={{
                            height: "100%",
                            minHeight: "100%",
                            maxHeight: "100%",
                            overflow: "auto",
                        }}>
                        <ContactoContainer
                            empresaId={empresaId}
                            contactos={empresaInfo?.contactos}/>
                    </TabPanel>
                    <TabPanel value={2}
                        sx={{
                            height: "100%",
                            minHeight: "100%",
                            maxHeight: "100%",
                            overflow: "auto",
                        }}>
                        <EmpresaUltimaVisita
                            ultimaVisita={empresaInfo?.ultimaVisita}/>
                    </TabPanel>
                    <TabPanel value={3}
                        sx={{
                            height: "100%",
                            minHeight: "100%",
                            maxHeight: "100%",
                            overflow: "auto",
                        }}>
                        <ComentariosDeals empresaId={empresaId}/>
                    </TabPanel>
                </Tabs>
            </div>
            }
        </div>
    );
}